import { CommonModule } from '@angular/common'
import { Component, Input } from '@angular/core'
import { MatDialog, MatDialogConfig, MatDialogModule } from '@angular/material/dialog'
import { MatDividerModule } from '@angular/material/divider'
import { MatIconModule } from '@angular/material/icon'
import { MatMenuModule } from '@angular/material/menu'
import { MatToolbarModule } from '@angular/material/toolbar'
import { RouterModule } from '@angular/router'
import { Subscription } from 'rxjs'
import { ThemeService } from 'src/app/service/theme/theme.service'
import { Themes } from '../../enums/enums'
import { DdcMobileSheetComponent } from '../ddc-mobile-sheet/ddc-mobile-sheet.component'
import { DialogLogout } from '../ddc-navbar/ddc-navbar.component'

@Component({
  selector: 'ddc-bottom-navbar',
  templateUrl: './ddc-bottom-navbar.component.html',
  styleUrls: ['./ddc-bottom-navbar.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatToolbarModule,
    MatIconModule,
    RouterModule,
    MatDialogModule,
    MatMenuModule,
    MatDividerModule,
  ],
})
export class DdcBottomNavbarComponent {
  @Input() _subscription: string = 'Free Tier'
  @Input() _theme: string = 'light-theme'
  @Input() _hasPic: boolean = false
  @Input() _isAdmin: boolean = false
  @Input() _isProfilePicLoading: boolean = false
  @Input() _userProfilePic: string = ''
  @Input() _DefaultProfilePic: string = '/assets/images/default-profile.png'
  @Input() _username: string = ''
  @Input() _isVerified: boolean = false

  _isLightTheme: boolean = true
  _isDarkTheme: boolean = false
  _isPaperTheme: boolean = false
  private themeSubscription: Subscription

  constructor(
    public themeService: ThemeService,
    private dialog: MatDialog,
  ) {
    this.themeSubscription = this.themeService.theme$.subscribe(theme => {
      this._isLightTheme = theme === Themes.LIGHT
      this._isDarkTheme = theme === Themes.DARK
      this._isPaperTheme = theme === Themes.PAPER
    })
  }

  openMobileAddDialog(): void {
    const dialogConfig = new MatDialogConfig()
    dialogConfig.position = { bottom: '0' }
    dialogConfig.width = '100%'
    dialogConfig.height = '80vh'
    dialogConfig.maxWidth = '100vw'
    dialogConfig.panelClass = ['mobile-sheet-container', this._theme]
    dialogConfig.hasBackdrop = true
    dialogConfig.backdropClass = 'mobile-sheet-backdrop'
    dialogConfig.enterAnimationDuration = '300ms'
    dialogConfig.exitAnimationDuration = '200ms'
    dialogConfig.data = { type: 'add' }
    const dialogRef = this.dialog.open(DdcMobileSheetComponent, dialogConfig)
  }

  openLogOutDialog(): void {
    this.dialog.open(DialogLogout)
  }
}
